import { useCallback } from 'react';
import { useGridStore } from '../state';

export function useProjectToggle() {
    const toggleProjectExpanded = useGridStore(state => state.toggleProjectExpanded);

    const handleToggle = useCallback(
        (projectId: string) => {
            toggleProjectExpanded(projectId);
        },
        [toggleProjectExpanded],
    );

    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent, projectId: string) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleProjectExpanded(projectId);
            }
        },
        [toggleProjectExpanded],
    );

    return { handleToggle, handleKeyDown };
}
